import { useTrans } from '../../../../services/i18n'
import React, { useEffect, useMemo, useState } from 'react'
import { Grid } from '@material-ui/core'
import Typography from '../../../../components/common/Typography'
import { Divider } from '../../../../components/common/Divider'
import Switch from '../../../../components/common/Inputs/Switch'
import CheckBox from '../../../../components/common/Inputs/CheckBox'
import FormControlLabel from '@material-ui/core/FormControlLabel'
import { ReactComponent as IconVLetter } from '../../../../components/assests/ico-V-letter.svg'
import { ReactComponent as IconALetter } from '../../../../components/assests/ico-A-letter.svg'
import { makeStyles } from '@material-ui/core/styles'
import connect from '../../connect'

const useStyles = makeStyles((theme) => ({
  moduleItem: {
    display: 'flex',
    flexGrow: 0,
    flexShrink: 0,
    flexBasis: '100%',
    maxWidth: '100%',
    [theme.breakpoints.up('sm')]: {
      flexBasis: '50%',
      maxWidth: '50%',
    },
    [theme.breakpoints.up('md')]: {
      flexBasis: '33.3333%',
      maxWidth: '33.3333%',
    },
    [theme.breakpoints.up('lg')]: {
      flexBasis: '20%',
      maxWidth: '20%',
    },
  },
  moduleItemInner: {
    alignContent: 'flex-start',
    width: '100%',
  },
  moduleHeaderRow: {
    display: 'flex',
    alignItems: 'center',
    justifyContent: 'space-between',
    width: '100%',
    gap: 12,
  },
  moduleHeaderLeft: {
    display: 'flex',
    alignItems: 'center',
    minWidth: 0,
    flex: 1,
  },
  moduleTitle: {
    fontSize: '15px',
    fontFamily: 'Lexend',
    fontWeight: 600,
    minWidth: 0,
    whiteSpace: 'nowrap',
    overflow: 'hidden',
    textOverflow: 'ellipsis',
  },
  switchWrap: {
    flex: '0 0 auto',
    display: 'flex',
    alignItems: 'center',
  },
}))

const MODULE_ORDER = ['workplace', 'registration', 'discovery', 'business', 'knowledge']
const MODULE_ORDER_INDEX = MODULE_ORDER.reduce((acc, key, idx) => {
  acc[key] = idx
  return acc
}, {})

const MODULE_LABELS = {
  workplace: 'Dashboard',
  registration: 'Registration',
  discovery: 'Market Research',
  business: 'Marketing',
  knowledge: 'Bid Ready',
}

const ManageFeatures = ({
  newUser = true,
  optionTab,
  updateSubscriptionSettings,
  subscriptionSettings,
}) => {
  const classes = useStyles()
  const { trans } = useTrans()
  const [modules, setModules] = useState([])

  const icons = {
    knowledge: null,
    workplace: null,
    discovery: null,
    business: null,
    registration: null,
  }

  const sortedModules = useMemo(() => {
    if (!Array.isArray(modules)) return []
    return [...modules].sort((a, b) => {
      const ai = MODULE_ORDER_INDEX[a?.key] ?? 999
      const bi = MODULE_ORDER_INDEX[b?.key] ?? 999
      return ai - bi
    })
  }, [modules])

  const updateData = () => {
    if (!subscriptionSettings) return
    const tabUsers = subscriptionSettings.find(obj => obj.idTab == optionTab)
    setModules(tabUsers?.existingUsers?.optionsList || [])
  }

  useEffect(() => {
    updateData()
  }, [subscriptionSettings, optionTab])

  const changeColumn = (ev, mo) => {
    const newData = subscriptionSettings.map(tab => {
      if (tab.idTab != optionTab) return tab

      let optionLists = []
      if (newUser) optionLists = tab.newUsers.optionsList
      else optionLists = tab.existingUsers.optionsList

      const auxOptionList = optionLists.map(option => {
        if (option.key != mo.key) return option

        const newOptions = option.submodules.map(opt => {
          return {
            ...opt,
            aCheckBox: ev.target.checked,
            vCheckBox: ev.target.checked,
            active: ev.target.checked,
          }
        })

        return {
          ...option,
          active: ev.target.checked,
          submodules: newOptions,
        }
      })

      return {
        ...tab,
        existingUsers: { optionsList: auxOptionList },
      }
    })

    updateSubscriptionSettings(newData)
  }

  const changeCheckbox = (ev, mo, checksOptions, vCheck) => {
    const isChecked = ev.target.checked

    const newData = subscriptionSettings.map(tab => {
      if (tab.idTab != optionTab) return tab

      const optionLists = tab.existingUsers.optionsList
      const auxOptionList = optionLists.map(option => {
        if (option.key != mo.key) return option

        const newOptions = option.submodules.map(opt => {
          if (opt.key != checksOptions.key) return opt

          if (vCheck) {
            return {
              ...opt,
              vCheckBox: isChecked,
              aCheckBox: isChecked ? opt.aCheckBox : false,
              active: isChecked ? opt.aCheckBox : false,
            }
          }

          return {
            ...opt,
            aCheckBox: isChecked,
            vCheckBox: isChecked ? true : opt.vCheckBox,
            active: isChecked,
          }
        })

        return {
          ...option,
          submodules: newOptions,
        }
      })

      return {
        ...tab,
        existingUsers: { optionsList: auxOptionList },
      }
    })

    updateSubscriptionSettings(newData)
  }

  return (
    <Grid
      container
      justifyContent="flex-start"
      alignItems="stretch"
      spacing={3}
      key={`tab-main-grid-checks-title-${optionTab}-${newUser ? 'new-users' : 'existing-users'}`}
    >
      {sortedModules.length > 0 &&
        sortedModules.map(column => {
          const label = MODULE_LABELS[column.key] || trans(column.key)

          return (
            <Grid
              item
              className={classes.moduleItem}
              key={`tab-grid-checks-title-${optionTab}-${column.key}-${newUser ? 'new-users' : 'existing-users'}`}
            >
              <Grid container className={classes.moduleItemInner}>
                <div className={classes.moduleHeaderRow}>
                  <div className={classes.moduleHeaderLeft}>
                    {icons[column.key] || null}

                    <Typography
                      className={classes.moduleTitle}
                      variant="body2"
                      title={label}
                      style={{
                        marginLeft: icons[column.key] ? '12px' : '0px',
                      }}
                    >
                      {label}
                    </Typography>
                  </div>

                  <div className={classes.switchWrap}>
                    <Switch
                      checked={column.active}
                      inputProps={{ 'aria-label': 'module' }}
                      color="primary"
                      onChange={ev => changeColumn(ev, column)}
                    />
                  </div>
                </div>

                <Divider light spacing={2} xs={12} style={{ width: '100%' }} />

                <Grid container item justifyContent="flex-start" xs={12} spacing={0}>
                  <Grid item xs={2}>
                    <IconVLetter />
                  </Grid>
                  <Grid item xs={2}>
                    <IconALetter />
                  </Grid>
                  <Grid item xs={8} />
                </Grid>

                {column.submodules.map(checksOptions => (
                  <Grid
                    container
                    item
                    justifyContent="flex-start"
                    xs={12}
                    key={`tab-grid-checks-options-${optionTab}-${checksOptions.key}-${newUser ? 'new-users' : 'existing-users'}`}
                    style={{ marginBottom: '0.6rem' }}
                  >
                    <Grid container item xs={2}>
                      <FormControlLabel
                        key={`checkbox-v-${optionTab}-${column.key}-${checksOptions.key}`}
                        control={
                          <CheckBox
                            color="secondary"
                            onChange={ev => changeCheckbox(ev, column, checksOptions, true)}
                            checked={checksOptions.vCheckBox}
                          />
                        }
                      />
                    </Grid>

                    <Grid item xs={10}>
                      <FormControlLabel
                        key={`tab-grid-a-check-option-${optionTab}-${checksOptions.key}`}
                        control={
                          <CheckBox
                            onChange={ev => changeCheckbox(ev, column, checksOptions, false)}
                            color="secondary"
                            checked={checksOptions.aCheckBox}
                            disabled={!checksOptions.vCheckBox}
                          />
                        }
                        label={checksOptions.name}
                      />
                    </Grid>
                  </Grid>
                ))}
              </Grid>
            </Grid>
          )
        })}
    </Grid>
  )
}

export default connect(ManageFeatures)
